import { cn } from '@/lib/utils'

interface InfoSizeShortItemProps {
  isActive?: boolean
  onClick?: () => void
  isDisabled?: boolean
  title: string
}

export const InfoSizeShortItem: React.FC<InfoSizeShortItemProps> = ({
  isActive,
  onClick,
  isDisabled,
  title,
}) => {
  return (
    <li>
      <button
        onClick={onClick}
        className={cn(
          'relative h-[30px] min-w-10 rounded-xl bg-neutral-100 px-2 font-sans text-sm leading-5 text-neutral-600 hover:bg-neutral-900 hover:text-light lg:bg-neutral-100 2xl:h-9 2xl:min-w-11',
          isDisabled &&
            'pointer-events-none cursor-not-allowed !bg-neutral-100/50 !text-neutral-300 before:absolute before:left-0 before:top-1/2 before:w-full before:rotate-[30deg] before:border-t before:border-dashed before:border-neutral-300 after:absolute after:left-0 after:top-1/2 after:w-full after:rotate-[145deg] after:border-t after:border-dashed after:border-neutral-300 lg:bg-neutral-100/50',
          isActive && 'bg-neutral-900 text-light lg:bg-neutral-900'
        )}
      >
        {title}
      </button>
    </li>
  )
}
